module.exports = __webpack_public_path__ + "assets/edf70933f1d6bf97674d6b1950a9ae4f.png";